import React from "react";
import { PanelShell, type PanelMeta } from "./PanelShell";

type WhatPanelProps = {
  panel: PanelMeta;
  headerColor: string;
  layoutEdit: boolean;
  reportMode?: boolean;
  resolvedStatus?: string | null;
  resolvedType?: string | null;
  resolvedIncorporation?: string | null;
  resolvedDissolution?: string | null;
  resolvedSector?: string | null;
  resolvedIndustry?: string | null;
  resolvedDivision?: string | null;
  resolvedSectionCode?: string | null;
  resolvedEmployeeBand?: string | null;
  resolvedPostTown?: string | null;
  resolvedCounty?: string | null;
  resolvedPostcode?: string | null;
  resolvedCountryRegion?: string | null;
  resolvedLastUpdated?: string | null;
  resolvedFilingSoftware?: string | null;
  displaySicCode1?: string | null;
  displaySicText1?: string | null;
  displaySicCode2?: string | null;
  displaySicText2?: string | null;
  formatDate: (value: string) => string;
  formatAgeDetailed: (value?: string | null) => string;
};

export function WhatPanel({
  panel,
  headerColor,
  layoutEdit,
  reportMode = false,
  resolvedStatus,
  resolvedType,
  resolvedIncorporation,
  resolvedDissolution,
  resolvedSector,
  resolvedIndustry,
  resolvedDivision,
  resolvedSectionCode,
  resolvedEmployeeBand,
  resolvedPostTown,
  resolvedCounty,
  resolvedPostcode,
  resolvedCountryRegion,
  resolvedLastUpdated,
  resolvedFilingSoftware,
  displaySicCode1,
  displaySicText1,
  displaySicCode2,
  displaySicText2,
  formatDate,
  formatAgeDetailed,
}: WhatPanelProps) {
  return (
    <PanelShell panel={panel} headerColor={headerColor} layoutEdit={layoutEdit} reportMode={reportMode}>
      <div className={`${reportMode ? "mt-2" : "mt-3"} grid grid-cols-2 gap-3 text-[11px] text-slate-600`}>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Status</span>
          <div className="text-slate-700">{resolvedStatus || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Type</span>
          <div className="text-slate-700">{resolvedType || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Incorporated</span>
          <div className="text-slate-700">
            {resolvedIncorporation ? formatDate(resolvedIncorporation) : "—"}
          </div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Age</span>
          <div className="text-slate-700">{formatAgeDetailed(resolvedIncorporation)}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Dissolved</span>
          <div className="text-slate-700">
            {resolvedDissolution ? formatDate(resolvedDissolution) : "—"}
          </div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Sector</span>
          <div className="text-slate-700">{resolvedSector || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Industry</span>
          <div className="text-slate-700">{resolvedIndustry || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Division</span>
          <div className="text-slate-700">{resolvedDivision || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Section</span>
          <div className="text-slate-700">{resolvedSectionCode || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Employees band</span>
          <div className="text-slate-700">{resolvedEmployeeBand || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Filing software</span>
          <div className="text-slate-700">{resolvedFilingSoftware || "—"}</div>
        </div>
        <div>
          <span className="uppercase text-[10px] tracking-wide text-slate-400">Last updated</span>
          <div className="text-slate-700">
            {resolvedLastUpdated ? formatDate(resolvedLastUpdated) : "—"}
          </div>
        </div>
        <div className="col-span-2">
          <span className="uppercase text-[10px] tracking-wide text-slate-400">SIC Code</span>
          <div className="text-slate-700 break-words">
            {displaySicCode1 || displaySicText1 ? (
              <div>
                {displaySicCode1 && <div className="font-medium">{displaySicCode1}</div>}
                {displaySicText1 && <div className="text-slate-500">{displaySicText1}</div>}
              </div>
            ) : (
              "—"
            )}
          </div>
          {displaySicCode2 || displaySicText2 ? (
            <div className="text-slate-700 mt-2 break-words">
              {displaySicCode2 && <div className="font-medium">{displaySicCode2}</div>}
              {displaySicText2 && <div className="text-slate-500">{displaySicText2}</div>}
            </div>
          ) : null}
        </div>
      </div>
    </PanelShell>
  );
}
